// eslint-disable-next-line no-underscore-dangle
var _curry = function _curry(fn) {
  var curried = function curried() {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    return t.length >= fn.length ? fn.call.apply(fn, [this].concat(t)) : curried.bind.apply(curried, [this].concat(t));
  };

  return curried;
}; // Types


// Functions
export function curry2(fn) {
  return _curry(fn);
}
export function curry3(fn) {
  return _curry(fn);
}
export function curry4(fn) {
  return _curry(fn);
}